module.exports = __webpack_public_path__ + "img/bannerLabel2Blue.fa3ed47e.png";